import React, { Fragment } from "react";
import { useFilters, useTable, usePagination, useSortBy, useGlobalFilter } from "react-table";
import { DefaultColumnFilter, GlobalFilter } from 'components/TableFilters';
import Pagination from "components/actions/Pagination";
import { useTranslation } from "react-i18next";
import LayoutWrapper from "./LayoutWrapper";
import { HiOutlineInbox } from "react-icons/hi";
import PropTypes from 'prop-types';

const TableContainer = ({ columns, data, globalSearch, isColumnFiltrable }) => {
	const { t } = useTranslation();

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		prepareRow,
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		setPageSize,
		state: { pageIndex, pageSize },
		state,
		preGlobalFilteredRows,
		setGlobalFilter,
	} = useTable({
		columns,
		data: data,
		defaultColumn: { Filter: DefaultColumnFilter },
		initialState: { hiddenColumns: ['_id'], pageIndex: 0, pageSize: 10 }
	},
		useGlobalFilter,
		useFilters,
		useSortBy,
		usePagination
		,);

	return (

		<div className="w-full h-full ">

			<div className="">
				{!!globalSearch &&
					<div className="my-2">
						<GlobalFilter
							preGlobalFilteredRows={preGlobalFilteredRows}
							globalFilter={state.globalFilter}
							setGlobalFilter={setGlobalFilter}
						/>
					</div>

				}

				{
					!!isColumnFiltrable &&
					<div className="my-2">
						<div className="flex flex-wrap">
							{headerGroups.map((headerGroup) =>
								headerGroup.headers.map((column) =>
									column.Filter && !column.Hidden ?
										(
											<div key={column.id} className="mr-4 my-2" >
												<label htmlFor={column.id} className="text-sm text-gray-800 font-medium mt-1">{column.render("Header")} </label>
												{column.render("Filter")}
											</div>
										) : null
								)
							)}
						</div>

					</div>

				}

			</div>


			<div className="overflow-x-auto my-4 border border-gray-200 rounded min-h-[480px]">
				<table
					className="min-w-full  w-full rounded bg-gray-100 divide-y divide-gray-200"
					{...getTableProps()}
				>
					<thead className="">
						{headerGroups.map((headerGroup) => (
							<tr className="capitalize" {...headerGroup.getHeaderGroupProps()}>
								{headerGroup.headers.map((column) => (
									<th className={`f px-6 py-2 text-left text-sm tracking-wider whitespace-nowrap`} {...column.getHeaderProps()}>
										<div className="" {...column.getSortByToggleProps()}>
											{column.render("Header")}
											{/* <span className="ms-1 font-medium text-lg"> {generateSortingIndicator(column)} </span> */}
										</div>
									</th>

								))}
							</tr>
						))}
					</thead>




					<tbody className=" min-h-fit" {...getTableBodyProps()}>

						{
							page.map((row, i) => {
								prepareRow(row);
								return (
									<Fragment key={row.getRowProps().key}>
										<tr className="border-t">
											{row.cells.map((cell) => {
												return (
													<td className="px-6 py-2 whitespace-nowrap bg-white" {...cell.getCellProps()}>{cell.render("Cell")}</td>
												);
											})}
										</tr>

									</Fragment>
								);
							})
						}
					</tbody>


				</table>
				{
					data?.length === 0 &&
					<div className="flex flex-col items-center justify-center bg-white w-full h-56 gap-2 text-gray-400">
						<HiOutlineInbox className="text-5xl" />
						<p className="text-sm font-medium">{t('table.no_data')}</p>
						<p className="text-xs">{t('table.no_data_description')}</p>
					</div>
				}
				{
					!data &&
					<LayoutWrapper loading={true} variant="table" />
				}


			</div>

			{
				data &&

				<Pagination
					canNextPage={canNextPage}
					canPreviousPage={canPreviousPage}
					nextPage={nextPage}
					previousPage={previousPage}
					gotoPage={gotoPage}
					pageCount={pageCount}
					setPageSize={setPageSize}
					pageSize={pageSize}
					pageOptions={pageOptions}
					pageIndex={pageIndex}
				/>
			}


		</div >
	);
};


TableContainer.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  globalSearch: PropTypes.bool,
  isColumnFiltrable: PropTypes.bool,
};

export default TableContainer;



